// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"logoContainer__3Y4K2","titleLink":"titleLink__2TFnY","altLogo":"altLogo__30OA9"};